import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSpiral = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon-spiral",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 3.75C6.89421 3.75 2.75 7.89421 2.75 13C2.75 17.1458 6.10421 20.5 10.25 20.5C14.3958 20.5 17.75 17.1458 17.75 13C17.75 9.82421 15.1758 7.25 12 7.25C8.82421 7.25 6.25 9.82421 6.25 13C6.25 15.2058 8.04421 17 10.25 17C12.4558 17 14.25 15.2058 14.25 13C14.25 11.7542 13.2458 10.75 12 10.75C11.5858 10.75 11.25 10.4142 11.25 10C11.25 9.58579 11.5858 9.25 12 9.25C14.0742 9.25 15.75 10.9258 15.75 13C15.75 16.0342 13.2842 18.5 10.25 18.5C7.21579 18.5 4.75 16.0342 4.75 13C4.75 8.99579 7.99579 5.75 12 5.75C16.0042 5.75 19.25 8.99579 19.25 13C19.25 17.9742 15.2242 22 10.25 22C5.27579 22 1.25 17.9742 1.25 13C1.25 7.06579 6.06579 2.25 12 2.25C17.9342 2.25 22.75 7.06579 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75C21.5858 13.75 21.25 13.4142 21.25 13C21.25 7.89421 17.1058 3.75 12 3.75Z",
			fill: "currentColor"
		})
	})
});
export { SvgIconSpiral as ReactComponent };
